import { TYPE_CUT } from "../nodedxf2";
export const ArcLine = (element, context, contour) => {
    let startAngle = element.StartAngle;
    let endAngle = element.EndAngle;
    let extrusion = false;
    if (endAngle === undefined)
        console.error("EndAngle is undefined ", element);
    if (startAngle === undefined)
        console.error("startAngle is undefined ", element);
    if (startAngle === endAngle) {
        startAngle = 0;
        endAngle = 360;
    }
    context.beginPath();
    context.save();
    context.translate(contour.scaleX(element.points[0].x), contour.scaleY(element.points[0].y));
    if (element.Extrusion && element.Extrusion.z !== 0) {
        context.scale(-1, -1);
    }
    else {
        context.scale(1, -1);
    }
    context.arc(0, 0, element.Radius * contour.scalefator, startAngle, // * (Math.PI / 180),
    endAngle, // * (Math.PI / 180),
    extrusion);
    if (element.named === "CIRCLE" && element.Type && element.Type === TYPE_CUT) {
        context.fillStyle = "#cbd5f4";
        context.fill();
    }
    context.stroke();
    context.closePath();
    context.restore();
};
